<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import ArrowIcon from '../../components/ArrowIcon.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isEditing: boolean;
  }>(),
  {}
);
const baseTableContentVM = new BaseTableContentViewModel();
// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
  (e: 'onCheckboxSelected', displayId: string, isAllSelected: boolean): void;
}>();
//変数
const t = i18n.t;
</script>

<template>
  <TableHead
    :class="[baseTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: baseTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    :index="headerIndex"
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !baseTableContentVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <template v-if="header.key === 'OrderControlChoice'">
      <RowCheckBox
        v-if="!isEditing"
        :is-checked="isAllSelected"
        class="md-primary all-check-button"
        @change-status="$emit('onCheckboxSelected', '', true)"
      />
    </template>
    <template v-else-if="header.sortOption.isSortable">
      <div class="table-header__sortable-content">
        {{ t(header.key) }}
        <div class="table-header__text">
          <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="table-header__text">{{ t(header.key) }}</div>
    </template>
  </TableHead>
</template>

<style scoped lang="scss"></style>
